import { IStyle } from '@fluentui/react';

export interface INameValueViewerStyles {
  root?: IStyle;
  pivotItem?: IStyle;
}

export interface INameValueViewerClassNames {
  root: string;
  pivotItem: string;
}

export const nameValueViewerStylesDefault: Partial<INameValueViewerStyles> = {
  root: {
    height: '100%',
  },
  pivotItem: {
    paddingTop: '8px',
    paddingBottom: '8px',
    height: '100%',
    position: 'relative',
  },
};
